// Login, signup and shared auth strings
const auth = {
  'Interface language': 'لغة الواجهة',

  'Failed to sign in with Google. Please try again.': 'تعذّر تسجيل الدخول عبر Google. حاول مرة أخرى.',
  'Google sign-in was cancelled or failed. Please try again.': 'تم إلغاء تسجيل الدخول عبر Google أو لم ينجح. حاول مرة أخرى.',
  'Failed to sign up with Google. Please try again.': 'تعذّر إنشاء الحساب عبر Google. حاول مرة أخرى.',
  'Google sign-up was cancelled or failed. Please try again.': 'تم إلغاء التسجيل عبر Google أو لم ينجح. حاول مرة أخرى.',
  'Failed to sign in. Please try again.': 'تعذّر تسجيل الدخول. حاول مرة أخرى.',
  'Failed to create account. Please try again.': 'تعذّر إنشاء الحساب. حاول مرة أخرى.',
  'Signing in...': 'جارٍ تسجيل الدخول...',
  'Creating account...': 'جارٍ إنشاء الحساب...',
  'Continue with Google': 'المتابعة باستخدام Google',
  'Google Sign-In is not configured': 'تسجيل الدخول عبر Google غير متاح حاليًا',

  '🎉 Limited Time: Get 1 FREE Video!': '🎉 لفترة محدودة: فيديو مجاني!',
  '🎉 Limited Time: Get 3 FREE Videos!': '🎉 لفترة محدودة: 3 فيديوهات مجانية!',
  'No credit card needed': 'بدون بطاقة بنكية',
  'AI-Powered Subtitles': 'ترجمة بالذكاء الاصطناعي',
  'for Arabic Dialects': 'للهجات العربية',
  'Darija, Masri, Khaleeji — we understand how you really speak. Create beautiful, accurate subtitles in seconds.':
    'الدارجة، المصرية، الخليجية — نفهم طريقتك الحقيقية في الكلام. أنشئ ترجمة دقيقة وجميلة في ثوانٍ.',
  '400M+': 'أكثر من 400 مليون',
  'Arabic speakers worldwide': 'متحدث بالعربية حول العالم',
  'Welcome back': 'مرحبًا بعودتك',
  "Don't have an account?": 'ليس لديك حساب؟',
  'Sign up for free': 'أنشئ حسابًا مجانًا',
  'or continue with email': 'أو تابع بالبريد الإلكتروني',
  'Email': 'البريد الإلكتروني',
  'Password': 'كلمة المرور',
  'Sign in': 'تسجيل الدخول',
  'By continuing, you agree to our': 'بالمتابعة، فإنك توافق على',
  'By creating an account, you agree to our': 'بإنشاء حساب، فإنك توافق على',
  'Terms of Service': 'شروط الخدمة',
  'Privacy Policy': 'سياسة الخصوصية',
  'Back to Login': 'العودة لتسجيل الدخول',
  ' and ': ' و',

  'Join the future of': 'انضم إلى مستقبل',
  'Arabic subtitles': 'الترجمة العربية',
  'Start creating beautiful, accurate subtitles for your content in minutes. No credit card required.':
    'ابدأ بإنشاء ترجمة دقيقة وجميلة لمحتواك في دقائق. بدون بطاقة بنكية.',
  '3 free videos included': '3 فيديوهات مجانية',
  'All Arabic dialects supported': 'جميع اللهجات العربية مدعومة',
  'Export in multiple formats': 'تصدير بعدة صيغ',
  'Create your account': 'أنشئ حسابك',
  'Already have an account?': 'لديك حساب بالفعل؟',
  '3 free videos': '3 فيديوهات مجانية',
  'All dialects': 'كل اللهجات',
  'No card': 'بدون بطاقة',
  'or sign up with email': 'أو سجّل بالبريد الإلكتروني',
  'First Name': 'الاسم',
  'Last Name': 'اسم العائلة',
  'Phone Number': 'رقم الهاتف',
  '(Optional)': '(اختياري)',
  'Create account': 'إنشاء حساب',
  'Audio': 'الصوت',

  // Generic API errors (src/api/client.js)
  'Unable to connect to the server. Please check your internet connection.': 'تعذّر الاتصال بالخادم. تحقق من اتصالك بالإنترنت.',
  'Please check your input and try again.': 'يُرجى التحقق من البيانات المدخلة والمحاولة مرة أخرى.',
  'Invalid email or password.': 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
  'This email is already registered. Please sign in instead.': 'هذا البريد الإلكتروني مسجل بالفعل. يُرجى تسجيل الدخول.',
  'You do not have permission to perform this action.': 'ليست لديك صلاحية للقيام بهذا الإجراء.',
  'Something went wrong on our end. Please try again later.': 'حدث خطأ من جهتنا. يُرجى المحاولة لاحقًا.',
  'An unexpected error occurred. Please try again.': 'حدث خطأ غير متوقع. حاول مرة أخرى.',
};

export default auth;
